import React, { useState } from 'react';
import DialogWrapper from '../../../../custom-ui/dialog/Dialog';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { createNewEntryForJobDetailsNewCollection } from '../../../../../data/jobDetailsNewCollection';
import toast from 'react-hot-toast';
import ToastAlert from '../../../../custom-ui/toast-alert/ToastAlert';

import { useNavigate } from 'react-router-dom';
import ButtonWrapper from './Button';
import EmojiFlagText from '../../../../custom-ui/emoji/EmojiFlagText';


interface Props {
    jobList: any;
    isFromAdmin?: boolean;
    toggleIsShowCopyExistingJobModal: () => void;
}

const CopyExistingJob = ({ jobList, toggleIsShowCopyExistingJobModal, isFromAdmin = false }: Props) => {
    const [selectedJobId, setSelectedJobId] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleChange = async (event: any) => {
        const jobId = event.target.value;
        setSelectedJobId(jobId);
    };


    const copyExistingJobToNewJob = async () => {

        const foundJob = jobList.find((job: any) => job.id === selectedJobId);
        setLoading(true);
        if (foundJob) {
            const { id,creditId,solutionType, ...rest } = foundJob;
            const modifiedJob = {
                ...rest,
                jobState: 'draft', 
                clicksCounter: 0,
                applyNowCounter: 0,
                makeLiveDate: null, 
                expirationDate: null,
                solutionType : !isFromAdmin? "job_board":solutionType,
                creditId: null,
                firstPublishedDate: null,
            };


            await createNewEntryForJobDetailsNewCollection(
                modifiedJob,
            )
                .then((id) => {
                    toast.success("Job (New) updated successfully");
                    if (isFromAdmin) {
                        navigate(`/jobs-new/${id}/${modifiedJob?.companyId}/information`)
                    } else {
                        navigate(`/jobs/${id}`)
                    }
                    setLoading(false);
                    toggleIsShowCopyExistingJobModal();
                    toast.success("Job copied successfully. You can now edit it.");
                })
                .catch(() => {
                    toast.error("There was an error updating Job (New)");
                    setLoading(false);
                    toast.error("Some error occurred while copying the job. Please try again.");
                });

        }
    }

    return (
        <DialogWrapper title='' size='w-[30vw]' onClose={() => null}>
            <>
                <div className="w-full sticky top-0 bg-white z-10 flex justify-between items-center">
                    <h1 className="text-instant-teams-blue-Main text-xl font-semibold">{isFromAdmin ? "Clone a Job" : "Copy Existing Job"}</h1>
                    <div
                        className="flex justify-center items-center w-7 h-7 bg-gray-100 rounded-full cursor-pointer"
                        onClick={toggleIsShowCopyExistingJobModal}
                    >
                        <FontAwesomeIcon icon={faTimes} color="#565656" />
                    </div>
                </div>
                <hr className="border-gray-300 my-4" />
                <p className='text-instant-teams-teal-Main mb-2'>Select a Job</p>


                <select
                    className="w-full border border-gray-300 rounded p-2 focus:outline-none focus:ring-2 focus:ring-instant-teams-blue-Main"
                    value={selectedJobId}
                    onChange={handleChange}
                >
                    <option value="">-- Select a job --</option>
                    {jobList.map((job: any) => (
                        <option key={job.id} value={job.id}>
                            <EmojiFlagText>{job.jobName}</EmojiFlagText>
                        </option>
                    ))}
                </select>

                <div className='text-center mt-8'>
                    <ButtonWrapper
                        onClick={copyExistingJobToNewJob}
                    >
                        {loading ? "Copying to new job..." : "Continue"}
                    </ButtonWrapper>
                </div>

                <ToastAlert />
            </>
        </DialogWrapper>
    );
};

export default CopyExistingJob;
